define([
	"csi/def/ActionFactory",
	"./Approve"
], function(ActionFactory,Approve) {

	return ActionFactory.declare("EndPhase", Approve, {
		m_tag: "EndPhase"
	});
});